module.exports = __webpack_public_path__ + "img/fiji-logo-icon.989ef0a3.png";